import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '../../../Typography/Typography';
import { Badge } from '../../../Badge';
import { badgeClasses as muiBadgeClasses } from '@mui/material/Badge';
import { badgeClasses } from '../../../Badge/badgeClasses';

const MultiSelectLabelRoot = styled('span')({
  display: 'flex'
});

const ItemLabelValue = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

const ItemLabelCounter = styled(Typography, {
  shouldForwardProp: prop => prop !== 'disabled'
})(({ theme, disabled }) => ({
  marginLeft: theme.spacing(2.5),
  marginRight: theme.spacing(1.75),
  background: theme.palette.background.default,
  [`& .${muiBadgeClasses.badge}.${badgeClasses.counter}`]: {
    color: disabled && theme.palette.action.disabled,
    background: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.background.default
  },
  display: 'flex',
  alignSelf: 'center'
}));

export const MultiSelectLabel = ({
  chipDefaultValue,
  value: values,
  disabled,
  maxSelectedItemsToDisplay = 1,
  CounterBadgeProps
}) => {
  if (!values || values.length === 0) {
    return chipDefaultValue;
  }

  const areAllLabelsVisible = values.length <= maxSelectedItemsToDisplay;
  const allLabels = values.map(({ label }) => label);
  const visibleLabels = areAllLabelsVisible
    ? allLabels
    : allLabels.slice(0, maxSelectedItemsToDisplay);

  if (areAllLabelsVisible) {
    return allLabels.join(', ');
  }

  const labelsAsString = visibleLabels.join(', ');
  const badgeContent = values.length - maxSelectedItemsToDisplay;

  return (
    <MultiSelectLabelRoot>
      <ItemLabelValue component="span" variant="button">
        {labelsAsString}
      </ItemLabelValue>
      <ItemLabelCounter component="span" variant="body2" disabled={disabled}>
        <Badge
          badgeContent={badgeContent}
          variant="counter"
          max={Infinity}
          {...CounterBadgeProps}
        />
      </ItemLabelCounter>
    </MultiSelectLabelRoot>
  );
};
